export const userAccessByType = Object.freeze({
    USER_TYPE_USER_ACCESS: 2,
    USER_TYPE_ADMIN_ACCESS: 1
});